import type { CampaignPriceResult } from '../campaign-price'

export interface Buy1Get1ValueMatchPriceParams {
  regularPrice: number
  originalPrice: number
  maxEligiblePriceForGift?: number
  isBuy1Get1ValueMatchActive?: boolean
}

/**
 * Tính giá cho campaign buy_1_get_1_value_match
 * Nếu regularPrice <= max_eligible_price_for_gift thì giảm về 0
 *
 * @returns CampaignPriceResult nếu campaign áp dụng, null nếu không áp dụng
 */
export function calculateBuy1Get1ValueMatchPrice({
  regularPrice,
  originalPrice,
  maxEligiblePriceForGift,
  isBuy1Get1ValueMatchActive,
}: Buy1Get1ValueMatchPriceParams): CampaignPriceResult | null {
  // Nếu campaign không active hoặc không có maxEligiblePriceForGift thì không áp dụng
  if (
    isBuy1Get1ValueMatchActive !== true ||
    maxEligiblePriceForGift === undefined ||
    maxEligiblePriceForGift <= 0 ||
    regularPrice > maxEligiblePriceForGift
  ) {
    return null
  }

  // Giảm giá về 0 cho sản phẩm đủ điều kiện
  const finalPrice = 0
  const discountPercent = originalPrice > 0 ? 100 : 0

  return {
    finalPrice,
    originalPrice,
    discountPercent,
    shouldShowDiscount: true,
  }
}
